﻿import RangeModel = require("./range.model");

export interface IScheduleModifierValidationRanges {
    property: RangeModel.IRange;
    liability: RangeModel.IRange;
    workersComp: RangeModel.IRange;
    umbrella: RangeModel.IRange;
}

export class ScheduleModifierValidationRanges implements IScheduleModifierValidationRanges {
    public property: RangeModel.IRange;
    public liability: RangeModel.IRange;
    public workersComp: RangeModel.IRange;
    public umbrella: RangeModel.IRange;
}